/* eslint-disable react-refresh/only-export-components */
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import { memo } from "react";

export interface CustomTabsProps extends TabsProps {
  handleChange?: (key: string) => void;
}

const CustomTabs = ({
  items = [],
  handleChange: handleChangeProp = () => {},
  ...restProps
}: CustomTabsProps) => {
  const handleChange = (key: string) => {
    handleChangeProp(key);
  };

  return (
    <Tabs
      className="font-semibold text-black"
      items={items}
      onChange={handleChange}
      destroyOnHidden
      {...restProps}
    />
  );
};

export default memo(CustomTabs);
